import request from '@/utils/request'

// 奖品兑换列表
export function VfPrizeRecord_index(data) {
  return request({
    url: '/Merchant/VfPrizeRecord/index',
    method: 'get',
    params: data
  })
}

// 经销商列表/抽奖客户列表
export function VfPrizeRecord_userList(data) {
  return request({
    url: '/Merchant/VfPrizeRecord/userList',
    method: 'get',
    params: data
  })
}

// 奖品列表
export function VfPrizeRecord_prizeList(data) {
  return request({
    url: '/Merchant/VfPrizeRecord/prizeList',
    method: 'get',
    params: data
  })
}
